import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { faFileExclamation } from '@fortawesome/pro-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { faCircleCheck, faCircleMinus } from '@fortawesome/pro-duotone-svg-icons';
import CustomToast from '../../../../../src/components/Toast';
import AssignmentsUsedBy from '../../../questionsSearch/components/AssignmentsUsedBy';
import { useState } from 'react';
import ActivityTypes from '../../../../enums/activityTypes';
import VocabularyDetailModal from './vocabularyDetailModal';

const VocabularyThumbnail = ({ 
  vocabulary,
  selectedVocabularies,
  setSelectedVocabularies,
  removeOnly,
  setDateBasedKey,
  viewMode,
  onRemove
}) => {
  const [showUsedByModal, setShowUsedByModal] = useState(false);
  const [showVocabularyDetailModal, setShowVocabularyDetailModal] = useState(false);

  const handleSelectVocabulary = (vocabularyDetails, e) => {
    e.stopPropagation();
    if (!vocabularyDetails.isSelected && selectedVocabularies.length >= 100) {
      CustomToast('You have already reached the maximum number of vocabularies', 'error');
      return;
    }

    vocabularyDetails.isSelected = !vocabularyDetails.isSelected;
    if (vocabularyDetails.isSelected) {
      setSelectedVocabularies([...selectedVocabularies, vocabularyDetails]);
    } else {
      setSelectedVocabularies(selectedVocabularies.filter(q => q.questionId != vocabularyDetails.questionId));
    }
    setDateBasedKey(new Date().getTime().toString());
  };

  const handleGetUsedByDetails = (e) => {
    e.stopPropagation();
    setShowUsedByModal(true);
  };
  
  return (
    <>
      <div className={`questionThumbnail ${viewMode > 0 && 'thumbnailHeight'} cursor-pointer`} onClick={()=> setShowVocabularyDetailModal(true)}>
        <div className='buttonContainer' >
          <div className='topBtnsContainer topLarge'>
            {vocabulary?.usedBy?.length > 0 &&
              <div className='editInfoBtn mt-3' onClick={(e) => handleGetUsedByDetails(e)}>
                <FontAwesomeIcon icon={faFileExclamation} />
                <div className='editInfoDescription'>Used in flashcard</div>
              </div>
            }
          </div>

          <div className='selectBtns'>
            <div className='d-flex flex-row justify-content-between'>
              <div style={{ height: '30px', width: '30px' }}></div>
              {vocabulary.inAssignment &&
                <div className='questionThumbnailButtons' onClick={(e) => { e.stopPropagation(); }}>
                  <OverlayTrigger
                    key="editToolTip"
                    placement="top"
                    overlay={<Tooltip className="custom-tooltip">Vocabulary in assignment</Tooltip>}>
                    <FontAwesomeIcon style={{ '--fa-primary-color': '#FFFFFF', '--fa-secondary-color': (removeOnly ? '#F79E9E' : '#9EDBC9'), '--fa-secondary-opacity': '1' }} icon={removeOnly ? faCircleMinus : faCircleCheck} />
                  </OverlayTrigger>
                </div>
              }

              {!vocabulary.inAssignment && !vocabulary.blockedText &&
                <div className='questionThumbnailButtons' onClick={(e) => { handleSelectVocabulary(vocabulary, e); }}>
                  {vocabulary.isSelected ?
                    <OverlayTrigger
                      key="editToolTip"
                      placement="top"
                      overlay={<Tooltip className="custom-tooltip">Unselect Vocabulary</Tooltip>}>
                      <FontAwesomeIcon style={{ '--fa-primary-color': '#FFFFFF', '--fa-secondary-color': (removeOnly ? '#F84646' : '#52C9A5'), '--fa-secondary-opacity': '1' }} icon={removeOnly ? faCircleMinus : faCircleCheck} />
                    </OverlayTrigger>
                    :
                    <OverlayTrigger
                      key="editToolTip"
                      placement="top"
                      style={{ zIndex: 10 }}
                      overlay={<Tooltip className="custom-tooltip">Select Vocabulary</Tooltip>}>
                      <FontAwesomeIcon color='#d4deff' icon={faCircle} />
                    </OverlayTrigger>
                  }
                </div>
              }
            </div>
          </div>
        </div>

        <div className='d-flex flex-column overflow-hidden' >
          <div style={{ fontSize: '0.85em' }}>{`ID: ${vocabulary.questionId}`}</div>
          <div style={{ fontSize: '0.85em' }}>{`Course: ${vocabulary.courseName}`}</div>
          <div style={{ fontSize: '0.85em' }}>{`Topic: ${vocabulary.topicName}`}</div>
          <div className='my-1' style={{ border: '1px solid #E7EDFF' }}></div>
          <div className={viewMode == 1 ? 'zoom-9' : viewMode == 2 ? 'zoom-7' : ''}>
            {vocabulary.blockedText ?
              <div className='text-danger fw-semibold fs-6' dangerouslySetInnerHTML={{ __html: vocabulary.blockedText }}></div>
              :
              <>
                {vocabulary.vocabulary &&
                <>
                  <div className='mt-2 mb-1 fw-bold'>Vocabulary</div>
                  <div dangerouslySetInnerHTML={{ __html: vocabulary.vocabulary }}></div>
                </>
                }

                {vocabulary.definition ?
                  <>
                    <div className='mt-2 mb-1 fw-bold'>Definition</div>
                    <div dangerouslySetInnerHTML={{ __html: vocabulary.definition }}></div>
                  </> : <></>}
              </>
            }
          </div>
        </div>
      </div>
      <AssignmentsUsedBy
        usedAssignments={vocabulary.usedBy}
        showUsedByModal={showUsedByModal}
        setShowUsedByModal={setShowUsedByModal}
        activityType={ActivityTypes.FlashCard}
      />
      {showVocabularyDetailModal &&
      <VocabularyDetailModal
        isOpen={showVocabularyDetailModal}
        onClose={() => setShowVocabularyDetailModal(false)}
        data={vocabulary}
        selectedVocabularies={selectedVocabularies}
        setSelectedVocabularies={setSelectedVocabularies}
        onRemove={onRemove}
      />
      }
    </>
  );
};

VocabularyThumbnail.propTypes = {
  vocabulary: PropTypes.object.isRequired,
  defaultChecked: PropTypes.bool,
  selectedVocabularies: PropTypes.array,
  setSelectedVocabularies: PropTypes.func,
  removeOnly: PropTypes.bool,
  setDateBasedKey: PropTypes.func,
  viewMode: PropTypes.number,
  onRemove: PropTypes.func
};

export default VocabularyThumbnail;